import { preffixTestIds } from 'utility/e2e'

export const RARUM_DIALOG_TEST_IDS = preffixTestIds('rarum-dialog')({
  CONFIRM_ACTION: 'confirm',
  CANCEL_ACTION: 'cancel',
})
